import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

// Session id kept in-memory only (module-scoped closure). No JS storage
// access → nothing for XSS to steal. Reset on full reload, which is fine
// for anonymous visitor analytics (privacy-friendly).
let VISITOR_SID = null;
const getOrCreateSessionId = () => {
  if (!VISITOR_SID) VISITOR_SID = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  return VISITOR_SID;
};

export default function AnalyticsTracker() {
  const location = useLocation();
  const { lang } = useI18n();
  const lastPath = useRef(null);

  useEffect(() => {
    if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/paiement")) return;
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    api.post("/analytics/pageview", {
      path: location.pathname,
      session_id: getOrCreateSessionId(),
      referrer: document.referrer || "",
      lang,
    }).catch((e) => { if (process.env.NODE_ENV === "development") console.warn("Analytics ping failed:", e?.message); });
  }, [location.pathname, lang]);

  return null;
}
